import styled from "styled-components";

export const Container = styled.div`
  position: sticky;
  top: ${({ theme }) => theme.space.headerMinHeight};
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.25rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    flex: unset;
  }
`;
